import { QPoint } from "./QPoint";

export class QPanelCollection {
  constructor() {
    this.fPanels = null;
    this.fWSMgr = null;
  }

  SetShownState(show) {
    if (this.fPanels == null) return;

    var n = this.fPanels.length;
    for (var i = 0; i < n; i++) this.fPanels[i].SetShownState(show);
  }

  InitCollection(theWSMgr) {
    this.fWSMgr = theWSMgr;
  }

  AddPanel(aPanel) {
    if (this.fPanels == null) this.fPanels = [];

    this.fWSMgr.PushPanel(aPanel);
    this.fPanels.push(aPanel);
  }

  GetImageMgr() {
    return this.fWSMgr.GetImageMgr();
  }

  RemovePanels() {
    if (this.fPanels != null) {
      var aPanel = this.fPanels.pop();
      while (aPanel != null) {
        if (aPanel.fPanelCollection != null) aPanel.fPanelCollection.RemovePanels();
        this.fWSMgr.RemovePanel(aPanel);
        aPanel = this.fPanels.pop();
      }
    }
  }

  GetHBounds(excludePanel) {
    var bounds = new QPoint();
    if (this.fPanels == null) return bounds;

    var n = this.fPanels.length;
    var leftEdge = 100000;
    var rightEdge = 0;

    for (var i = 0; i < n; i++) {
      var p = this.fPanels[i];

      if (p != excludePanel) {
        var pLeft = p.GetPositionX();
        var pRight = p.GetWidth() + pLeft;

        if (pLeft < leftEdge) leftEdge = pLeft;

        if (pRight > rightEdge) rightEdge = pRight;
        bounds.fX = leftEdge;
        bounds.fY = rightEdge;
      }
    }

    return bounds;
  }
}
